import styled from 'styled-components';
import Mod001 from 'dc/Mod001';
import { Typ30, Typ31, Typ40, Typ50 } from 'dc/Typ';
import Btn021 from 'dc/Btn021';
import Btn020 from 'dc/Btn020';
import Sef001 from 'dc/Sef001';

export const Modal = styled(Mod001)`
  width: 646px !important;
  > div {
    border-radius: 5px;
    box-shadow:
      0 15px 20px rgba(0, 0, 0, 0.22),
      0 19px 60px rgba(0, 0, 0, 0.3);
  }
`;

export const UpperWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: transparent;
  text-align: center;
  margin-top: 40px;
  margin-bottom: 32px;
`;

export const Heading = styled(Typ50)`
  width: 100%;
  padding-bottom: 32px;
  color: #455a64;
`;

export const Content1 = styled(Typ40)`
  width: 70%;
  padding-bottom: 16px;
  white-space: pre-wrap;
  color: #455a64;
`;

export const Content2 = styled(Typ40)`
  width: 70%;
  padding-bottom: 32px;
  white-space: pre-wrap;
  color: #455a64;
`;

export const StartButton = styled(Btn021)`
  margin-bottom: 8px;
  width: 223px;
  background-color: #007079;
  box-shadow:
    0 2px 2px rgba(0, 0, 0, 0.24),
    0 0 4px rgba(0, 0, 0, 0.12);
`;

export const MoreButton = styled(Btn020)`
  span {
    color: #007079;
  }
`;

type ExpandedWrapperProps = {
  shown?: boolean;
};

export const ExpandedWrapper = styled.div<ExpandedWrapperProps>`
  display: ${props => (props.shown ? 'flex' : 'none')};
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: #f4f7f9;
  text-align: center;
  padding-top: 32px;
`;

export const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: transparent;
  text-align: left;
  width: 430px;
  color: #455a64;
`;

export const DetailsTitle = styled(Typ31)`
  width: 100%;
  color: #455a64;
`;

type DetailsTextProps = {
  bottom?: boolean;
};

export const DetailsText = styled(Typ30)<DetailsTextProps>`
  margin-bottom: ${props => (props.bottom ? '40px' : '24px')};
  width: 100%;
  color: #455a64;
`;

export const Footer = styled(Sef001)`
  width: 100%;
  background-color: #fff;
  span {
    color: #007079;
  }
`;
